import defaultAsset from '@assets/assetIcons/default_asset.png';
import unknownMarker from '@assets/assetIcons/unkown_asset.png';

export const ASSET_ICONS = {
	UNKNOWN: unknownMarker,
	DEFAULT_ASSET: defaultAsset,
};
